"use strict";
// File generated from our OpenAPI spec
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiVersion = void 0;
exports.ApiVersion = '2024-11-20.acacia';
